var bookApplication = angular.module ( 'bookApplication' , 
    [ 'ui.router', 'ngSanitize', 'bookModule', 'documentFilters', 'documentDirectives' ] );

bookApplication.config ( 
    [ '$stateProvider' , '$locationProvider', '$urlRouterProvider', '$urlMatcherFactoryProvider',
    function ( $stateProvider , $locationProvider, $urlRouterProvider, $urlMatcherFactoryProvider ) {
        $stateProvider
            .state ( 'matrix' , {
                url : '/:chapterString/:pathwayString' ,
                templateUrl: './templates/matrix.html' 
            })
        $stateProvider
            .state ('matrix.dictionary', {
                url : '/:dictionaryTerm',
                templateUrl: "./../common/templates/dictionary.html"
            });

        $locationProvider.html5Mode ( {
                enabled : true ,
                requireBase : true ,
                rewriteLinks : true
        } );

        $urlMatcherFactoryProvider.strictMode(false);

        $urlRouterProvider.otherwise('/home/');
    } ]
);